import React, { Component } from 'react';
import Aux from '../../../components/Hoc/Aux';
import { Link } from 'react-router-dom';
import { Tooltip } from 'react-tippy';
import VimeoEmbed from '../../../components/VimeoEmbed/VimeoEmbed';
import medicare2027Thumb from '../../../assets/video/medicare-2027-thumb.jpg';
import ReasonsResults from '../../../components/Reasons/ReasonsResults';
import Testimonials from '../../../components/Testimonials/Testimonials';
import Accordion from '../../../components/Accordion/Accordion';
import getMedicareFaqs from '../../../helpers/medicareFaqs';

import cdphpLogo from '../../../assets/logo.svg';
import originalMedicareCard from '../../../assets/compare/original-medicare-card.jpg';
import Physical from '../../../assets/compare/icon-annual-physical.svg';
import Dental from '../../../assets/compare/icon-dental.svg';
import Hospital from '../../../assets/compare/icon-hospital.svg';
import OutOfNetwork from '../../../assets/compare/icon-out-of-network.svg';
import OutOfPocket from '../../../assets/compare/icon-out-of-pocket.svg';
import Prescription from '../../../assets/compare/icon-prescriptions.svg';
import PrimaryCare from '../../../assets/compare/icon-primary-care.svg';
import Specialist from '../../../assets/compare/icon-specialist.svg';
import Surgery from '../../../assets/compare/icon-surgery.svg';
import UrgentCare from '../../../assets/compare/icon-urgent-care.svg';
import Worldwide from '../../../assets/compare/icon-worldwide.svg';
// import Rating from '../../../assets/compare/icon-rating.svg';

class MedicareCompare extends Component {
  tableEl = null;

  setHeaderOffset = () => {
    const header = document.querySelector('header.locked');
    const h = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--header-h', `${h}px`);
    this.checkStuck();
  };

  checkStuck = () => {
    if (!this.tableEl) return;
    const headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h')) || 0;
    const top = this.tableEl.getBoundingClientRect().top;
    this.tableEl.classList.toggle('stuck', top <= headerH);
  };

  componentDidMount () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'GAEvent',
      'eventCategory': 'View',
      'eventAction': 'Landing',
      'eventLabel': 'Plans - Medicare Compare Upgrade',
      'eventValue': undefined
    });

    this.setHeaderOffset();
    window.addEventListener('resize', this.setHeaderOffset);
    window.addEventListener('scroll', this.checkStuck, { passive: true });
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.setHeaderOffset);
    window.removeEventListener('scroll', this.checkStuck);
  }

  render () {
    const accordionData = getMedicareFaqs({ planType: 'hmo' });

    return (
      <Aux>
        <header className='locked landingPage upgrade'>
          <div className='main'>
            <div>
              <Link to='/' className='logo'>
                <img src={cdphpLogo} alt='CDPHP | Capital District Physicians&rsquo; Health Plan' />
              </Link>
            </div>
            <div className='connect'>
              <p>
                <strong>Ready to get coverage for 2027?</strong>
                <span><a href='tel:855-345-5884' className='tel'>855-345-5884</a> | <em>M-F, 8 a.m. – 8 p.m.<sup>‡</sup></em></span>
              </p>
            </div>
            {/* <a href='https://cdphpmedicare1.destinationrx.com/PC/2027/Shopping/Home?AgentID=cdphp-funnel'
              target='_blank'
              rel='noopener noreferrer'
              className='btn sm'>Enroll Online
            </a> */}
          </div>
        </header>
        <article id='medicareCompare' className='upgrade'>

          <section className='intro'>
            <div className='wrap'>
              <h1>2027 Medicare Advantage Plans</h1>
            </div>
            <div className='wrap sm'>
              <div className='callout'>
                <div className='content'>
                  <p><strong>Happy with your current plan?</strong> You don&apos;t need to do anything. You&apos;ll be automatically enrolled for January 1, 2027, and your coverage continues without a gap.</p>
                  <p><strong>Want to make a change?</strong> CDPHP has 2027 plan options with the familiar benefits, healthy extras, and support you count on. Compare plans and enroll by December 31, 2026.</p>
                </div>
                <VimeoEmbed
                  videoId='1231058000'
                  hash='ad22a9fc81'
                  title='2027 Medicare Member Video'
                  thumbnail={medicare2027Thumb}
                  popover />
              </div>
            </div>
          </section>

          <section>
            <div className='wrap sm'>
              <div className='results medicare container'>
                <div className='table' ref={el => { this.tableEl = el; }}>
                  <table>
                    <thead>
                      <tr className='heading'>
                        <th>
                          <div className=''>
                            <img src={originalMedicareCard} className='original' alt='Original Medicare - Parts A & B' />
                          </div>
                          <strong>$202<sup>.90</sup></strong>/mo.
                          <Tooltip
                            className='tip'
                            html={(<span className='originalMedicare'>Most people pay the standard Part B monthly premium amount ($202.90 in 2026). Visit <a href='https://www.medicare.gov/basics/costs' target='_blank' rel='noopener noreferrer'>Medicare.gov</a> to learn more.</span>)}
                            arrow='true'
                            interactive='true'
                          >
                            <span className='helpTip'>Estimated Monthly Cost</span>
                          </Tooltip>
                        </th>
                        <th>
                          <div className='card'>
                            <img src={cdphpLogo} alt='CDPHP | Capital District Physicians&rsquo; Health Plan' />
                            <h4>$0 Rx (HMO)</h4>
                          </div>
                          <strong>$0</strong>/mo.
                          {/* <span>
                            <a href='https://cdphpmedicare1.destinationrx.com/PC/2027/Shopping/Home?AgentID=cdphp-funnel'
                              target='_blank'
                              rel='noopener noreferrer'
                              className='btn sm'>Enroll
                            </a>
                          </span> */}
                        </th>
                        <th>
                          <div className='card'>
                            <img src={cdphpLogo} alt='CDPHP | Capital District Physicians&rsquo; Health Plan' />
                            <h4>Clear Rx (HMO)</h4>
                          </div>
                          <strong>$100</strong>/mo.
                          {/* <span>
                            <a href='https://cdphpmedicare1.destinationrx.com/PC/2027/Shopping/Home?AgentID=cdphp-funnel'
                              target='_blank'
                              rel='noopener noreferrer'
                              className='btn sm'>Enroll
                            </a>
                          </span> */}
                        </th>
                        <th>
                          <div className='card'>
                            <img src={cdphpLogo} alt='CDPHP | Capital District Physicians&rsquo; Health Plan' />
                            <h4>Choice Rx (HMO)</h4>
                          </div>
                          <strong>$139</strong>/mo.
                          {/* <span>
                            <a href='https://cdphpmedicare1.destinationrx.com/PC/2027/Shopping/Home?AgentID=cdphp-funnel'
                              target='_blank'
                              rel='noopener noreferrer'
                              className='btn sm'>Enroll
                            </a>
                          </span> */}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td colSpan={4} className='section'>Deductibles</td>
                      </tr>
                      <tr>
                        <td><strong>$283</strong><span>Medical</span></td>
                        <td><strong>$0</strong><span>Medical</span></td>
                        <td><strong>$0</strong><span>Medical</span></td>
                        <td><strong>$0</strong><span>Medical</span></td>
                      </tr>
                      <tr>
                        <td className='nope'><strong>No Coverage</strong> <span>Prescription<br />&nbsp;</span></td>
                        <td><strong>$700</strong><span>Prescription<br />tiers 2-5</span></td>
                        <td><strong>$500</strong><span>Prescription<br />tiers 3-5</span></td>
                        <td><strong>$250</strong><span>Prescription<br />tiers 3-5</span></td>
                      </tr>
                      <tr>
                        <td colSpan={4} className='section'>Benefits</td>
                      </tr>
                      <tr>
                        <td className='nope'><strong>No Coverage</strong> <span>Annual Physicals</span></td>
                        <td><img src={Physical} /><strong>$0</strong><span>Annual Physicals</span></td>
                        <td><img src={Physical} /><strong>$0</strong><span>Annual Physicals</span></td>
                        <td><img src={Physical} /><strong>$0</strong><span>Annual Physicals</span></td>
                      </tr>
                      <tr>
                        <td><img src={Hospital} /><Tooltip title='With Original Medicare, you will have a $1,364 deductible for the first 60 days, $341/day from days 61-90, and $682/day for each “lifetime reserve day” after day 90 for each benefit period (up to 60 days over your lifetime) for inpatient hospitalizations. CDPHP Medicare plans protect you from potentially high, unexpected costs by instead offering a flat, predictable copay.' arrow='true'><span className='helpTip'>See Details</span></Tooltip><span>Hospital Stays</span></td>
                        <td><img src={Hospital} /><strong>$460</strong>/day <span>days 1-5, then $0<br />Hospital Stays</span></td>
                        <td><img src={Hospital} /><strong>$395</strong>/day <span>days 1-6, then $0<br />Hospital Stays</span></td>
                        <td><img src={Hospital} /><strong>$260</strong>/day <span>days 1-6, then $0<br />Hospital Stays</span></td>
                      </tr>
                      <tr>
                        <td colSpan={4} className='section'>Allowances</td>
                      </tr>
                      <tr>
                        <td className='nope'><strong>No Coverage</strong> <span>Dental</span></td>
                        <td><img src={Dental} /><strong>$400</strong>/yr. <span>Dental</span></td>
                        <td><img src={Dental} /><strong>$900</strong>/yr. <span>Dental</span></td>
                        <td><img src={Dental} /><strong>$1,500</strong>/yr. <span>Dental</span></td>
                      </tr>
                      <tr>
                        <td className='nope'><strong>No Coverage</strong> <span>Prescription Drugs</span></td>
                        <td><img src={Prescription} /><Tooltip title='Pricing for prescription drugs is based on a variety of factors, but in general, generic and brand-name drugs that have a proven clinical advantage are typically less expensive, whereas experimental drugs, or those without a proven clinical advantage, tend to be more expensive.' arrow='true'><strong className='helpTip'>$5 - 29%<br />of Bill</strong></Tooltip><span>Prescription Drugs</span></td>
                        <td><img src={Prescription} /><Tooltip title='Pricing for prescription drugs is based on a variety of factors, but in general, generic and brand-name drugs that have a proven clinical advantage are typically less expensive, whereas experimental drugs, or those without a proven clinical advantage, tend to be more expensive.' arrow='true'><strong className='helpTip'>$0 - 28%<br />of Bill</strong></Tooltip><span>Prescription Drugs</span></td>
                        <td><img src={Prescription} /><Tooltip title='Pricing for prescription drugs is based on a variety of factors, but in general, generic and brand-name drugs that have a proven clinical advantage are typically less expensive, whereas experimental drugs, or those without a proven clinical advantage, tend to be more expensive.' arrow='true'><strong className='helpTip'>$0 - 37%<br />of Bill</strong></Tooltip><span>Prescription Drugs</span></td>
                      </tr>
                      <tr>
                        <td colSpan={4} className='section'>Care</td>
                      </tr>
                      <tr>
                        <td><img src={PrimaryCare} /><strong>20%</strong> of Bill <span>Primary Care</span></td>
                        <td><img src={PrimaryCare} /><strong>$0</strong> <span>Primary Care</span></td>
                        <td><img src={PrimaryCare} /><strong>$0</strong> <span>Primary Care</span></td>
                        <td><img src={PrimaryCare} /><strong>$0</strong> <span>Primary Care</span></td>
                      </tr>
                      <tr>
                        <td><img src={Specialist} /><strong>20%</strong> of Bill <span>Specialist Doctor</span></td>
                        <td><img src={Specialist} /><strong>$50</strong> <span>Specialist Doctor</span></td>
                        <td><img src={Specialist} /><strong>$40</strong> <span>Specialist Doctor</span></td>
                        <td><img src={Specialist} /><strong>$35</strong> <span>Specialist Doctor</span></td>
                      </tr>
                      <tr>
                        <td><img src={Surgery} /><strong>20%</strong> of Bill <span>Outpatient Surgery</span></td>
                        <td><img src={Surgery} /><strong>$315 - $365</strong> <span>Outpatient Surgery</span></td>
                        <td><img src={Surgery} /><strong>$275 - $350</strong> <span>Outpatient Surgery</span></td>
                        <td><img src={Surgery} /><strong>$200 - $250</strong> <span>Outpatient Surgery</span></td>
                      </tr>
                      <tr>
                        <td><img src={UrgentCare} /><strong>20%</strong> of Bill <span>Urgent Care</span></td>
                        <td><img src={UrgentCare} /><strong>$40</strong> <span>Urgent Care</span></td>
                        <td><img src={UrgentCare} /><strong>$50</strong> <span>Urgent Care</span></td>
                        <td><img src={UrgentCare} /><strong>$50</strong> <span>Urgent Care</span></td>
                      </tr>
                      <tr>
                        <td colSpan={4} className='section'>Coverage</td>
                      </tr>
                      <tr>
                        <td className='nope'><strong>No Coverage</strong> <span>Out-of-Network</span></td>
                        <td><img src={OutOfNetwork} /><strong>Emergency Only</strong> <span>Out-of-Network</span></td>
                        <td><img src={OutOfNetwork} /><strong>Emergency Only</strong> <span>Out-of-Network</span></td>
                        <td><img src={OutOfNetwork} /><strong>Emergency Only</strong> <span>Out-of-Network</span></td>
                      </tr>
                      <tr>
                        <td className='nope'><strong>No Coverage</strong> <span>Emergency Care Worldwide</span></td>
                        <td><img src={Worldwide} /><strong>$115</strong> <span>Emergency Care Worldwide</span></td>
                        <td><img src={Worldwide} /><strong>$115</strong> <span>Emergency Care Worldwide</span></td>
                        <td><img src={Worldwide} /><strong>$100</strong> <span>Emergency Care Worldwide</span></td>
                      </tr>
                      <tr>
                        <td colSpan={4} className='section'>Protection</td>
                      </tr>
                      <tr>
                        <td className='nope'><strong>No Coverage</strong> <span>Maximum Out-of-Pocket</span></td>
                        <td><img src={OutOfPocket} /><strong>$9,850</strong>/yr. <span>Maximum Out-of-Pocket</span></td>
                        <td><img src={OutOfPocket} /><strong>$6,750</strong>/yr. <span>Maximum Out-of-Pocket</span></td>
                        <td><img src={OutOfPocket} /><strong>$6,400</strong>/yr. <span>Maximum Out-of-Pocket</span></td>
                      </tr>
                      {/* <tr>
                        <td colSpan={4} className='section'>Rating</td>
                      </tr>
                      <tr>
                        <td className='nope'><strong>Not Applicable</strong></td>
                        <td><img src={Rating} alt='4.5 out of 5 Medicare Ranking' /><strong>4.5</strong> Stars</td>
                        <td><img src={Rating} alt='4.5 out of 5 Medicare Ranking' /><strong>4.5</strong> Stars</td>
                        <td><img src={Rating} alt='4.5 out of 5 Medicare Ranking' /><strong>4.5</strong> Stars</td>
                      </tr> */}
                    </tbody></table>
                  {/* <p className='medicare-desc'>*Your cost share (copays and coinsurances) may be different for Out-of-Network services.</p> */}
                </div>
              </div>
            </div>
          </section>

          <ReasonsResults intro="More Reasons Why You'll Love Us" type='medicare' />
          <Testimonials heading='&ldquo;CDPHP treats you like someone they know and care about.&rdquo;' slides='medicare' />

          <section id='faq'>
            <div className='wrap sm'>
              <h2>Frequently Asked Questions</h2>
              {accordionData.map(({ index, title, content }) => (
                <Accordion
                  key={index}
                  id={'faq' + index}
                  title={title}
                  content={content} />
              ))}
            </div>
          </section>
        </article>
      </Aux>
    );
  }
}

export default MedicareCompare;